import React from "react";

import { CSSGrid } from "@components/Layout/CssGrid";

import {
  InteriorWindows,
  Fridge,
  ForkSpoonKnife,
  CoffeeMachine as CoffeeMachineIcon,
  TextileMaterial,
} from "@ui/Assets/MyIcons";

import { getItem } from "./Tabs.helpers";

const Dishwashing = getItem(
  "extras_service_dishwashing",
  ForkSpoonKnife,
  "Dishwashing",
);

const InsideFridge = getItem(
  "extras_service_inside_fridge",
  Fridge,
  "InsideFridge",
);

const GlassWalls = getItem(
  "extras_service_glass_walls",
  InteriorWindows,
  "GlassWalls",
);

const CoffeeMachine = getItem(
  "extras_service_coffee_machine",
  CoffeeMachineIcon,
  "CoffeeMachine",
);

const Laundry = getItem("extras_service_laundry", TextileMaterial, "Laundry");

export const b2bAreas = CSSGrid.areas({
  Dishwashing,
  InsideFridge,
  GlassWalls,
  CoffeeMachine,
  Laundry,
});

b2bAreas.all(
  (
    { Dishwashing, InsideFridge, GlassWalls, CoffeeMachine, Laundry },
    { compose, repeat },
  ) => [
    compose(repeat(Dishwashing, 6), repeat(InsideFridge, 6)),
    compose(repeat(GlassWalls, 6), repeat(CoffeeMachine, 6)),
    repeat(Laundry, 6),
  ],
);

b2bAreas.smallTablet(
  (
    { Dishwashing, InsideFridge, GlassWalls, CoffeeMachine, Laundry },
    { compose, repeat },
  ) => [
    compose(
      repeat(Dishwashing, 4),
      repeat(InsideFridge, 4),
      repeat(GlassWalls, 4),
    ),
    compose(repeat(CoffeeMachine, 4), repeat(Laundry, 4)),
  ],
);
